"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.entity = exports.server = void 0;
const behavior_1 = __importDefault(require("../behavior"));
const server = function (serv) {
    serv.behavior = (0, behavior_1.default)(serv);
};
exports.server = server;
const entity = function (entity) {
    entity.behavior = (0, behavior_1.default)(entity);
};
exports.entity = entity;
